import { useState, useEffect } from "react";
import Header from "../../components/molecules/header/Header"
import Footer from "../../components/molecules/footer/Footer"
import DataTable from "react-data-table-component";
import ConstantesTabla from "../../utils/ConstantesTabla";
import { getCentros, getCentrosSeleccionados, guardarOrdenCentros, obtenerListaExclusiones } from "../../components/services/ConcursosService";
import { useNavigate, useParams } from "react-router-dom";
import "./anexoI2.scss"

import { Iconos } from "../../utils/Iconos";
import ModalExclusionCentros from "../../components/molecules/modals/modalExclusionCentros/ModalExclusionCentros";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";

const SeleccionCentros = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [show, setShow] = useState({
    mensaje: false,
  });
  const handleClose = (e) => {
    setShow(false);
  };

  const [showEnviar, setShowEnviar] = useState({
    mensaje: false,
  });
  const handleCloseEnviar = (e) => {
    setShowEnviar(false);
  };

  const [centros, setCentros] = useState([]);
  const [exclusiones, setExclusiones] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]); // Para manejar filas seleccionadas con su orden
  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false); // Estado para controlar si se seleccionan/desmarcan todas las filas

  useEffect(() => {
    getCentros(params.idCon, params.idSol).then((data) => {
      

      setCentros(data);
      setLoading(false);
    });
    obtenerListaExclusiones(params).then((data) => {
      
      setExclusiones(data);

    })

    Promise.all([
      getCentros(params.idCon, params.idSol),
      getCentrosSeleccionados(params.idCon, params.idSol) // Obtén los puestos seleccionados
    ]).then(([centrosData, centrosSeleccionadosData]) => {
      setCentros(centrosData);

      // Procesa los puestos seleccionados y combínalos con los datos generales
      const selected = centrosSeleccionadosData.map((seleccionado, index) => {
        // Busca el puesto correspondiente en la lista de puestos
        const centro = centrosData.find(p => p.codcentro === seleccionado.codcentro);
        if (centro) {
          return { row: centro, order: index + 1 }; // Incluye orden basado en el índice
        }
        return null; // Excluye los datos no encontrados
      }).filter(Boolean); // Elimina valores nulos

      setSelectedRows(selected); // Actualiza los puestos seleccionados
      setLoading(false);
    });
  }, [params]);

  // Función para manejar la selección de filas individualmente
  const handleCheckboxChange = (row, checked) => {
    setSelectedRows((prevSelectedRows) => {
      if (checked) {
        // Añadir fila seleccionada
        return [...prevSelectedRows, { row, order: prevSelectedRows.length + 1 }];
      } else {
        // Remover fila deseleccionada y reasignar órdenes
        const updatedRows = prevSelectedRows.filter(
          (selected) => selected.row !== row
        );
        return updatedRows.map((selected, index) => ({
          ...selected,
          order: index + 1,
        }));
      }
    });
    

  };

  // Función para manejar la selección de todas las filas
  const handleSelectAll = (checked) => {
    setSelectAll(checked); // Actualiza el estado del checkbox general
    if (checked) {
      // Si el checkbox general está marcado, selecciona todas las filas
      const allSelectedRows = centros.map((row, index) => ({
        row,
        order: index + 1,
      }));
      setSelectedRows(allSelectedRows);
    } else {
      // Si está desmarcado, deselecciona todas las filas
      setSelectedRows([]);
    }
  };

  // Definir las columnas para la tabla
  const columnas = [
    {
      name: (
        <input
          type="checkbox"
          className="form-check-input m-1 p-1"
          title="Selecciona todos los puestos"
          aria-label="Selecciona todos los puestos"
          checked={selectAll} // Controla el estado del checkbox general
          onChange={(e) => handleSelectAll(e.target.checked)} // Maneja el evento de selección/desmarcar todo
        />
      ),
      selector: (row) => (
        <input
          type="checkbox"
          className="form-check-input m-1 p-1"
          title="Selecciona un puesto"
          aria-label={`Selecciona el puesto ${row.codcentro} - ${row.centro} - ${row.codconsejeria} - ${row.consejeria}`}
          checked={selectedRows.some((selected) => selected.row === row)}
          onChange={(e) => handleCheckboxChange(row, e.target.checked)}
        />


      ),
      grow: .1

    },
    {
      name: "Preferencia",
      selector: (row) => {
        const selectedRow = selectedRows.find((selected) => selected.row === row);
        const order = selectedRow ? selectedRow.order : null;

        return (
          <div className="ordenAct row">
            <div className="col-8">
              <input
                type="number"
                min={1}
                className="form-control"
                value={order || ""}
                readOnly // Solo lectura, ya que el orden lo asignamos automáticamente
              />
            </div>
          </div>
        );
      },
    },

  ];

  const columnasExclusion = [
    {
      name: <div>Exclusiones</div>,
      selector: (row) =>
        <div className="cursorPointer"
          tabIndex={0}
          onClick={() => {
            setShow({
              mensaje: true,
              otherContent:
                'Ponga nombre a su solicitud para poder identificar el fichero electrónico; es texto libre, escriba lo que quiera: p.e. "Concurso 1"',
              tipo: "tituloModal",
            });
          }}
          role="button"
          title="Exclusiones"
          aria-label="Exclusiones"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === " ") {
              setShow({
                mensaje: true,
                otherContent:
                  'Ponga nombre a su solicitud para poder identificar el fichero electrónico; es texto libre, escriba lo que quiera: p.e. "Concurso 1"',
                tipo: "tituloModal",
              });
            }
          }}
        >{Iconos.iconoExclusionCentros}</div>,
      center: true
    }
  ]
  return (<>
    <Header />
    <div className="containerSeleccionCentros" role="main" data-landmark-index="4">
      {/*<Titulo
        tipo={"tituloPagina"}
        titulo={`Selección de Centros`}
      />*/}
      <h2 className="tituloPagina">Selección de Centros</h2>

      <div className="mensajeInfo fondo">
        <p>
          Ahora puede indicar cuáles son sus preferencias de puestos,
          haciendo click para marcar los puestos elegidos y cumplimentando
          el orden de preferencia de cada uno.
        </p>
      </div>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <div className="contTabla mt-5 d-flex flex-column justify-content-center">
          <div className="container tablacolumnasTablaSeleccionCentros card">
            <DataTable
              className="table-responsive"
              columns={[...columnas, ...ConstantesTabla.columnasTablaSeleccionCentros, ...columnasExclusion]}
              data={centros}
              pagination
              paginationComponentOptions={ConstantesTabla.paginacionOpt}
              noDataComponent={<span>No se encontraron centros</span>}
              customStyles={ConstantesTabla.customStyles}
              width="auto"
              fixedHeader

              subHeaderWrap={true}
              style={{ marginTop: "20px" }}
            />
          </div>
        </div>
      )}
      <div className="buttons row align-items-md-center" >
        {/* <ButtonVolver
          clases={"btn-card"}
          destino={`consModSolicitudes/${params.idCon}/${params.idSol}`}
        ></ButtonVolver> */}
        <div className="col-md-2 order-1 order-md-0">
          <button
            type="button"
            className="btnRed rounded btnCancelarDocumentacion py-3 px-4 align-items-center"
            onClick={() =>
              navigate(`/consModSolicitudes/${params.idCon}/${params.idSol}`)
            }
          >
            <i className="fa-solid fa-rotate-left"></i> Volver
          </button>
        </div>
        {/* <Button
          clases={"rounded btnCancelarDocumentacion col-11 col-md-2 fs-5 fw-bold order-1 order-md-2"}
          nombre={"Grabar"}
          funcion={() => {
            // if (puestosAenviar.length !== 0) {
            //   if (
            //     localStorage.getItem("puestosSeleccionados") === null
            //   ) {
            //     localStorage.setItem(
            //       "puestosSeleccionados",
            //       JSON.stringify(puestosAenviar)
            //     );
            //   } else {
            //     let puestosJson = JSON.parse(
            //       localStorage.getItem("puestosSeleccionados")
            //     );
            //     puestosJson = puestosJson.concat(puestosAenviar);
            //     localStorage.setItem(
            //       "puestosSeleccionados",
            //       JSON.stringify(puestosJson)
            //     );
            //   }
            //   navigate(`consModSolicitudes/${params.idCon}/${params.idSol}`, {state:{adscripcion:adscripcion}});
            // } else {
            //   setShow({
            //     mensaje: true,
            //     content: "Debe seleccionar un puesto",
            //     tipo: "tituloModal",
            //     destinoCerrar: null,
            //   });
            // }
            
            
            guardarOrdenCentros(selectedRows, params).then((data) => {
              
              setShowEnviar({
                mensaje: true,
                enviado: true,
                content: "Centros enviados correctamente.",
                contentBold: "",
                tipo: "tituloModal",
                aviso: true,
                destinoAviso: null,
                destinoCerrar: null,
              });
            })

          }}
        /> */}
        <div className="col-md-2 order-0 order-md-1">
          <button
            type="button"
            className="btn rounded btnCancelarDocumentacion py-3 px-4 col-md-2 fs-5 fw-bold"
            onClick={() => {
              // if (puestosAenviar.length !== 0) {
              //   if (
              //     localStorage.getItem("puestosSeleccionados") === null
              //   ) {
              //     localStorage.setItem(
              //       "puestosSeleccionados",
              //       JSON.stringify(puestosAenviar)
              //     );
              //   } else {
              //     let puestosJson = JSON.parse(
              //       localStorage.getItem("puestosSeleccionados")
              //     );
              //     puestosJson = puestosJson.concat(puestosAenviar);
              //     localStorage.setItem(
              //       "puestosSeleccionados",
              //       JSON.stringify(puestosJson)
              //     );
              //   }
              //   navigate(`consModSolicitudes/${params.idCon}/${params.idSol}`, {state:{adscripcion:adscripcion}});
              // } else {
              //   setShow({
              //     mensaje: true,
              //     content: "Debe seleccionar un puesto",
              //     tipo: "tituloModal",
              //     destinoCerrar: null,
              //   });
              // }

              //poner otro modal diciendo que no hay centros

              
              
              guardarOrdenCentros(selectedRows, params).then((data) => {
                
                if (selectedRows.length !== 0) {
                  setShowEnviar({
                    mensaje: true,
                    enviado: true,
                    content: "Centros enviados correctamente.",
                    contentBold: "",
                    tipo: "tituloModal",
                    aviso: true,
                    destinoAviso: null,
                    destinoCerrar: null,
                  });
                }else{
                  setShowEnviar({
                    mensaje: true,
                    enviado: true,
                    content: "No hay centros disponibles.",
                    contentBold: "",
                    tipo: "tituloModal",
                    aviso: true,
                    destinoAviso: null,
                    destinoCerrar: null,
                  });
                }

              })

            }}
          >
            Grabar
          </button>
        </div>
      </div>
    </div>
    <Footer />
    {show.mensaje ? (
      <ModalExclusionCentros
        show={show.mensaje}
        handleClose={handleClose}
        titulo={show.content}
        tipo={show.tipo}
        aviso={show.aviso}
        destinoAviso={show.destinoAviso}
        otherContent={show.otherContent}
        destinoCerrar={show?.destinoCerrar}
        exclusiones={exclusiones}
      ></ModalExclusionCentros>
    ) : null}

    {showEnviar.mensaje ? (
      <ModalMensajes
        show={showEnviar.mensaje}
        handleClose={handleCloseEnviar}
        texto={showEnviar?.content}
        tipo={showEnviar?.tipo}
        destinoCerrar={showEnviar?.destinoCerrar}
      ></ModalMensajes>
    ) : null}
  </>);
};

export default SeleccionCentros;
